import { createSelector, createSelectorCreator, defaultMemoize } from 'reselect';
import { get, merge, isEqual } from 'lodash';

import config from 'config/config';

export const selectFirestore = createSelectorCreator(defaultMemoize, isEqual)(
    state => state.firestore,
    firestore => firestore,
);

export const selectRouter = state => state.router;

export const selectLocation = createSelector(selectRouter, ({ location }) => location);

export const selectIdFromProps = (_, { id }) => id;

export const selectListPendingFactory = selectPending => createSelector(selectPending, pending => pending.list);

export const selectDetailPendingFactory = selectPending => createSelector(selectPending, pending => pending.detail);

export const selectItemPendingFactory = selectPending =>
    createSelector(selectPending, selectIdFromProps, (pending, id) => get(pending, id, false));

export const selectItemForUpdateFactory = (itemKey, defaultValues) =>
    createSelector(selectFirestore, selectIdFromProps, (firestore, id) =>
        config.app.languages.reduce(
            (data, lang) => {
                const item = merge({}, defaultValues, get(firestore.data, `${itemKey}<${id},${lang}>`));
                data[lang] = item;
                return data;
            },
            { id },
        ),
    );
